import React, { useState } from 'react';
import { Modal, Accordion } from 'react-bootstrap';
import { ALLERGENS } from './MenuAllergens';
import './MenuPreview.css';

const MenuPreview = ({ menu, show, onClose }) => {
  const [activeKey, setActiveKey] = useState(null);

  const handleSelect = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  return (
    <Modal 
      show={show} 
      onHide={onClose}
      centered
      fullscreen="sm-down"
      dialogClassName="menu-preview-modal"
      contentClassName="preview-modal-content"
    >
      <Modal.Body>
        <div className={`menu-preview theme-${menu?.theme || 'minimale'}`}>
          {menu?.logo_url && (
            <div className="hero-banner">
              <img src={menu.logo_url} alt={menu.name} className="hero-image"/>
            </div>
          )}
          
          <div className="menu-container">
            <div className="menu-header">
              <h1 className="menu-title">{menu?.name}</h1>
              {menu?.subtitle && <p className="menu-subtitle">{menu.subtitle}</p>}
            </div>

            <Accordion activeKey={activeKey} onSelect={handleSelect}>
              {menu?.sections?.map(section => (
                <Accordion.Item key={section.id} eventKey={section.id}>
                  <Accordion.Header>{section.name}</Accordion.Header>
                  <Accordion.Body>
                    <div className="section-items">
                      {section.items?.map(item => (
                        <div key={item.id} className="menu-item">
                          <div className="item-header">
                            <h3 className="item-name">{item.name}</h3>
                            <span className="item-price">
                              {item.price ? `€${parseFloat(item.price).toFixed(2)}` : ''}
                            </span>
                          </div>
                          {item.description && (
                            <p className="item-description">{item.description}</p>
                          )}
                          {item.allergens?.length > 0 && (
                            <div className="allergens-row">
                              {item.allergens.map(allergenKey => {
                                const allergen = ALLERGENS[allergenKey];
                                return allergen && (
                                  <div key={allergenKey} className="allergen">
                                    <div className="allergen-icon">
                                      <allergen.icon 
                                        width={24} 
                                        height={24} 
                                        outerColor={allergen.color}
                                        innerColor="#ffffff"
                                      />
                                    </div>
                                    <span className="allergen-tooltip">{allergen.label}</span>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      </Modal.Body>
      <div className="preview-footer">
        <button 
          type="button" 
          className="btn btn-secondary preview-close-button" 
          onClick={onClose}
        >
          Chiudi
        </button>
      </div>
    </Modal>
  );
};

export default MenuPreview;
